import { createSlice } from '@reduxjs/toolkit';
import {
  changePasswordBuilder,
  fetchVendorInfoBuilder,
  loginBuilder,
  logoutBuilder,
  renewCodeForVendorBuilder,
  sendRecoveryCodeForgotPasswordBuilder,
  signUpBuilder,
  verifyEmailBuilder,
} from './builder';

const initialState = {
  email: '',
  code: '',
  password: '',
  loggedIn: null,
  setPlaceId: '',
  error: null,
  verifyEmailPending: false,
  createAccountPending: false,
  changePasswordPending: false,
  sendingCodePending: false,
  sendRecoveryCodeForgotPasswordPending: false,
  renewCodeForVendorPending: false,
  loginPending: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoggedIn: (state, { payload }) => {
      const { loggedIn } = payload;
      state.loggedIn = loggedIn;
    },
    setEmailInput: (state, { payload }) => {
      state.email = payload;
    },
    setPasswordInput: (state, { payload }) => {
      state.password = payload;
    },
    setCodeInput: (state, { payload }) => {
      state.code = payload;
    },
  },
  extraReducers: builder => {
    signUpBuilder(builder);
    loginBuilder(builder);
    sendRecoveryCodeForgotPasswordBuilder(builder);
    verifyEmailBuilder(builder);
    logoutBuilder(builder);
    renewCodeForVendorBuilder(builder);
    changePasswordBuilder(builder);
    fetchVendorInfoBuilder(builder);
    builder.addCase('logout', () => ({ ...initialState, loggedIn: false }));
  },
});

export const { setLoggedIn, setEmailInput, setCodeInput, setPasswordInput } = authSlice.actions;

export const selectLoggedIn = state => state.auth.loggedIn;
export const selectLoggedPending = state => state.auth.loginPending;
export const selectEmailInput = state => state.auth.email;
export const selectPasswordInput = state => state.auth.password;
export const selectCodeInput = state => state.auth.code;
export const selectSendRecoveryCodeForgotPasswordPending = state => state.auth.sendRecoveryCodeForgotPasswordPending;
export const selectChangePasswordPending = state => state.auth.changePasswordPending;
export const selectVerifyEmailPending = state => state.auth.verifyEmailPending;
export const selectCreateAccountPending = state => state.auth.createAccountPending;

export default authSlice.reducer;
